import { AxiosError, AxiosResponse } from 'axios';
import { computed, action, makeObservable, observable, reaction } from 'mobx';
import TranslationApi from '../api/TranslationApi';
import KeyVal from '@util/KeyVal';
import { parseParams } from '@util/ParamsUtil';
import LanguageStore from './LanguageStore';
import RootStore from './RootStore';

class TranslateStore {
  public _translationsPromise: Promise<void> = Promise.resolve(); // expose to test only
  @observable public initializationCompleted: boolean = false;
  @observable private translations: KeyVal = {};

  private defaultTranslateAppName = 'distfront';
  private globalTranslateAppName = 'global';
  private languageStore: LanguageStore;

  /**
   *
   * @param rootStore
   */
  constructor(rootStore: RootStore) {
    makeObservable(this);
    this.languageStore = rootStore.languageStore;

    if (rootStore.initialState.translations) {
      this.translations = rootStore.initialState.translations;
    }

    if (this.languageStore.initialLanguageChanged || !rootStore.initialState.translations) {
      this.updateTranslations(this.languageStore.currentLanguage);
    }

    reaction(
        () => this.languageStore.currentLanguage,
        (lang) => this.updateTranslations(lang)
    );
  }

  @computed
  public get currentTranslations(): KeyVal {
    return this.translations;
  }

  /**
   *
   */
  @computed
  public get globalTranslations(): KeyVal {
    return this.currentTranslations[this.globalTranslateAppName] || {};
  }

  // @action
  // public async init() {
  //   reaction(() => this.languageStore.currentLanguage, (lang) => this.updateTranslations(lang));
  //   await this.updateTranslations(this.languageStore.currentLanguage);
  // }

  /**
   *
   * @param translations
   */
  @action
  private setTranslations = (translations: KeyVal) => {
    this.translations = translations || {};
  };

  /**
   *
   * @param lang
   * @private
   */
  private updateTranslations(lang: string) {
    this._translationsPromise = this._translationsPromise
        .then(() => TranslationApi.getTranslations(lang))
        .then((response: AxiosResponse) => this.setTranslations(response.data.translations))
        .catch((e: AxiosError) => {
          console.error(e);
        })
        .finally(() => (this.initializationCompleted = true));
  }

  /**
   *
   * @param key
   * @param paramObject
   */
  public translate = (key: string, paramObject?: KeyVal) =>
      this.getTranslationForGroup(this.defaultTranslateAppName, key, paramObject);

  /**
   *
   * @param key
   * @param paramObject
   */
  public translateGlobal = (key: string, paramObject?: KeyVal) =>
      this.getTranslationForGroup(this.globalTranslateAppName, key, paramObject);

  /**
   *
   * @param group
   * @param key
   * @param paramObject
   */
  private getTranslationForGroup = (group: string, key: string, paramObject?: KeyVal) => {
    const groupTranslations = this.translations[group];
    let textValue;

    if (groupTranslations) {
      textValue = groupTranslations[key];
    }

    if (textValue) {
      if (paramObject) {
        return parseParams(textValue, paramObject);
      }
      return textValue;
    }
    return `${group}:${key}`;
  };
}

export default TranslateStore;
